<template>
    <div>
        <div id="menu">
            <b-container>
                <b-nav>
                  <b-nav-item to="/dashboard/profile/account" active-class="active">{{ $t("profile.menu.account") }}</b-nav-item>
                  <b-nav-item to="/dashboard/profile/comm" active-class="active">{{ $t("profile.menu.comm") }}</b-nav-item>
                  <b-nav-item to="/dashboard/profile/auth" active-class="active">{{ $t("profile.menu.auth") }}</b-nav-item>
                  <b-nav-item to="/dashboard/profile/sessions" active-class="active">{{ $t("profile.menu.sessions") }}</b-nav-item>
                </b-nav>
            </b-container>
        </div>

        <b-container id="content">
            <!-- Cообщения -->
            <message-view></message-view>
            <!-- Компонент -->
            <router-view></router-view>
        </b-container>
    </div>
</template>

<script>
    import MessageView from "@/components/MessageView";
export default {
    name: 'UserProfile',
    components: {
        MessageView
    }
}
</script>